import { Button, Stack, Typography, useTheme } from "@mui/material";
import { MessageCircle } from "lucide-react";
import type { FC } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	title: string;
	description: string;
	actionLabel: string;
	onAction: () => void;
};

export const ChatListEmptyState: FC<Props> = ({
	title,
	description,
	actionLabel,
	onAction,
}) => {
	const theme = useTheme();

	return (
		<Stack alignItems="center" justifyContent="center" px={3.2} py={6.4}>
			<IconBox
				bg={theme.palette.grey[100]}
				size={64}
				borderRadius={theme.radii.xl}
				mb={1.6}
			>
				<MessageCircle size={28} color={theme.palette.grey[400]} />
			</IconBox>
			<Typography variant="h4" textAlign="center" mb={0.4}>
				{title}
			</Typography>
			<Typography variant="body2" textAlign="center" lineHeight={1.6}>
				{description}
			</Typography>
			<Button variant="textLink" onClick={onAction} sx={{ mt: 1.2 }}>
				{actionLabel}
			</Button>
		</Stack>
	);
};
